export default __webpack_public_path__ + "static/media/guard.c5c7fc62.svg";